import { DomainBase } from "./DomainBase";

export class WebUserMenuPermission extends DomainBase {
    constructor() {
        super();
        this.UserRole = null;
        this.MenuPermissions = [];
    }
}